import type {ReactElement} from 'react';
import {useState} from 'react';
import Logo from '@components/Logo/Logo';
import {NavLink} from 'react-router-dom';
import {Trans} from '@lingui/macro';
import BalanceBlock from '@components/Menu/BalanceBlock/BalanceBlock';
import Burger from '@assets/images/burger.svg';
import {clsx} from 'clsx';
import Fade from '@components/Animation/Fade/Fade';
import styles from './menu.module.scss';
import Cross from '@components/Cross';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';

export default function Menu(): ReactElement {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const query = useQueryWithAuth({
        queryKey: ['me'],
        queryFn: me,
        refetchOnWindowFocus: true,
    });

    const menuClassNames = clsx([styles.main, {[styles.active]: isMenuOpen}]);

    function handleButtonClick() {
        setIsMenuOpen(!isMenuOpen);
    }

    function handleMenuClose() {
        setIsMenuOpen(false);
    }

    return (
        <div className={styles.root}>
            <button className={styles.burger} onClick={handleButtonClick}>
                <img src={Burger} />
            </button>
            <div className={menuClassNames}>
                <div className={styles.header}>
                    <Cross onClick={handleMenuClose} className={styles.close} />
                    <Logo className={styles.logo} />
                </div>
                <NavLink to="/feedback" onClick={handleMenuClose}>
                    <div className={styles.item}>
                        <Trans>Feedback</Trans>
                    </div>
                </NavLink>
                {query.data?.data.role === 'admin' && (
                    <NavLink to="/admin" onClick={handleMenuClose}>
                        <div className={styles.item}>
                            <Trans>Admin</Trans>
                        </div>
                    </NavLink>
                )}
                <NavLink className={styles.mobileOnly} to="/topup" onClick={handleMenuClose}>
                    <div className={styles.item}>
                        <Trans>Top up</Trans>
                    </div>
                </NavLink>
                <NavLink className={styles.mobileOnly} to="/profile" onClick={handleMenuClose}>
                    <div className={styles.item}>
                        <Trans>Profile</Trans>
                    </div>
                </NavLink>
            </div>
            <div className={styles.flexer} />
            <div className={styles.side}>
                <BalanceBlock />
                <NavLink className={styles.desktopOnly} to="/profile">
                    <div className={styles.item}>
                        <Trans>Profile</Trans>
                    </div>
                </NavLink>
            </div>
            <Fade in={isMenuOpen} unmountOnExit>
                <div className={styles.menuBackground} onClick={handleMenuClose} />
            </Fade>
        </div>
    );
}
